import React from 'react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Range } from 'react-range';
import './Filters.css';

const Filters = ({
  startDate,
  endDate,
  handleDateRangeChange,
  selectedTideType,
  setSelectedTideType,
  maxCoefficient,
  setMaxCoefficient,
  weekendOnly,
  setWeekendOnly,
  timeRange,
  setTimeRange,
  startHour,
  endHour,
  displayArcachon,
  setDisplayArcachon,
  displayCapFerret,
  setDisplayCapFerret
}) => {
  return (
    <div className="filters-grid">
      {/* Ligne 1 */}
      <div className="dates">
        <label className="filter-label">Dates :</label>
        <ReactDatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateRangeChange}
          isClearable
          placeholderText="Sélectionner plage de dates"
          className="date-picker"
          popperPlacement="bottom-start" // 👈 Force l'affichage vers la droite
          //onFocus={(e) => e.target.blur()}
          onFocus={(e) => e.target.readOnly = true}
        />
        <label className="filter-label">
          Weekend:
          <input
            type="checkbox"
            checked={weekendOnly}
            onChange={e => setWeekendOnly(e.target.checked)}
            className="checkbox-input"
          />
        </label>
      </div>
      <div>
        
        <label className="filter-label">
          Arcachon:
          <input
            type="checkbox"
            checked={displayArcachon}
            onChange={e => setDisplayArcachon(e.target.checked)}
            className="checkbox-input"
          />          
        </label>
        <label className="filter-label">
          Cap Ferret:
          <input
            type="checkbox"
            checked={displayCapFerret}
            onChange={e => setDisplayCapFerret(e.target.checked)}
            className="checkbox-input"
          />
        </label>
      </div>
        
      

      <div className="slider">
        <label className="filter-label">
          Heures : de {startHour}h à {endHour}h
        </label>
        <div className="slider-wrapper">
          <Range
            step={1}
            min={0}
            max={24}
            values={timeRange}
            onChange={setTimeRange}
            renderTrack={({ props, children }) => (
              <div {...props} className="slider-track">
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div {...props} className="slider-thumb" />
            )}
          />
        </div>
      </div>

      <div className="tide">
        <label className="filter-label">Type de marée :</label>
        <select
          value={selectedTideType}
          onChange={e => setSelectedTideType(e.target.value)}
          className="select-input"
        >
          <option value="">-- Toutes --</option>
          <option value="highTide">Marée haute</option>
          <option value="lowTide">Marée basse</option>
        </select>
      </div>

      
      <div className="coef">
        <label className="filter-label">Coeff max :</label>
        <input
          type="number"
          value={maxCoefficient}
          onChange={e => setMaxCoefficient(e.target.value)}
          className="number-input"
        />
      </div>


      
    </div>
  );
};

export default Filters;
